import { ROLE, type Role } from '../contexts/CustomerHubContext'

/**
 * In-store Custom Made reorder gate (RP-5643).
 *
 * The Reorder CTA is allowed only when:
 *  - the session is in-store (Style Advisor) — never the consumer webstore
 *    (done-when criterion 3), and
 *  - the order line carries a configuration id to deep-link the configurator;
 *    a missing/empty id must not render a dead CTA (criterion 5).
 */
/**
 * The session params PredictSpring puts on the URL it opens the hub with, which
 * custom-made needs to start an in-store session. `identifier` is PredictSpring's
 * secure-FE key, not any token the hub holds (`authToken` is an Entra bearer for
 * the APIM APIs), so the only way to get it here is to receive it at entry.
 */
export function readInStoreReorderContext(search: string) {
  const params = new URLSearchParams(search)
  return {
    identifier: params.get('identifier') ?? undefined,
    storeId: params.get('storeId') ?? undefined,
  }
}

export function canReorderCustomMade(
  role: Role | undefined,
  configurationId: string | undefined | null,
): boolean {
  return role === ROLE.STYLE_ADVISOR && Boolean(configurationId)
}
